import React, { useState } from 'react';
import { useContactSubmit } from '../hooks/useAirtable';

const Contact = () => {
  const [formData, setFormData] = useState({
    name: '',
    email: '',
    message: '',
    type: 'general'
  });

  const { submitForm, loading, error, success } = useContactSubmit();

  const handleSubmit = async (e) => {
    e.preventDefault();
    await submitForm(formData);
    if (!error) {
      setFormData({ name: '', email: '', message: '', type: 'general' });
    }
  };

  const handleChange = (e) => {
    setFormData({
      ...formData,
      [e.target.name]: e.target.value
    });
  };

  return (
    <div className="contact">
      <section className="page-hero" style={{backgroundImage: `url(${process.env.PUBLIC_URL + '/images/hero/hero-background.jpg'})`, backgroundSize: 'cover', backgroundPosition: 'center'}}>
        <div className="container">
          <h1 className="page-title">Get In Touch</h1>
          <p className="page-subtitle">Join our community or learn how we can work together</p>
        </div>
      </section>

      <section className="section">
        <div className="container">
          <div className="grid grid-2">
            <div className="contact-info">
              <h2>Let's Connect</h2>
              <p>
                Whether you're from a rural community looking to develop skills, 
                or a business seeking talented virtual assistants, we'd love to 
                hear from you.
              </p>
              <div style={{marginTop: '2rem'}}>
                <div style={{marginBottom: '1rem'}}>
                  <strong>Email:</strong> connect@rippluence.com
                </div>
                <div>
                  <strong>Community:</strong> Join our growing network
                </div>
              </div>
            </div>

            <form className="contact-form" onSubmit={handleSubmit}>
              {success && (
                <div style={{
                  background: '#d4edda',
                  color: '#155724',
                  padding: '1rem',
                  borderRadius: '0.5rem',
                  marginBottom: '1rem',
                  border: '1px solid #c3e6cb'
                }}>
                  Thank you for your message! We'll get back to you soon.
                </div>
              )}

              {error && (
                <div style={{
                  background: '#f8d7da',
                  color: '#721c24',
                  padding: '1rem',
                  borderRadius: '0.5rem',
                  marginBottom: '1rem',
                  border: '1px solid #f5c6cb'
                }}>
                  Error: {error}
                </div>
              )}

              <div className="form-group">
                <label htmlFor="name">Full Name</label>
                <input
                  type="text"
                  id="name"
                  name="name"
                  value={formData.name}
                  onChange={handleChange}
                  className="form-control"
                  required
                  disabled={loading}
                />
              </div>

              <div className="form-group">
                <label htmlFor="email">Email Address</label>
                <input
                  type="email"
                  id="email"
                  name="email"
                  value={formData.email}
                  onChange={handleChange}
                  className="form-control"
                  required
                  disabled={loading}
                />
              </div>

              <div className="form-group">
                <label htmlFor="type">I'm interested in</label>
                <select
                  id="type"
                  name="type"
                  value={formData.type}
                  onChange={handleChange}
                  className="form-control"
                  disabled={loading}
                >
                  <option value="general">General Information</option>
                  <option value="join">Joining as VA</option>
                  <option value="hire">Hiring VAs</option>
                  <option value="partner">Partnership</option>
                </select>
              </div>

              <div className="form-group">
                <label htmlFor="message">Message</label>
                <textarea
                  id="message"
                  name="message"
                  rows="5"
                  value={formData.message}
                  onChange={handleChange}
                  className="form-control"
                  required
                  disabled={loading}
                ></textarea>
              </div>

              <button 
                type="submit" 
                className="btn btn-primary"
                disabled={loading}
              >
                {loading ? 'Sending...' : 'Send Message'}
              </button>
            </form>
          </div>
        </div>
      </section>
    </div>
  );
};

export default Contact;